<template>
  <div class="page_all">
    <div class="return_link">
      <router-link to="/areaList">＞ 地域</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div v-if="this.changeFlg" class="title">地域の編集</div>
        <div v-else class="title">地域の追加</div>
        <div class="area_radios_div">
          <div class="area_radio_div">
            <input class="area_radio_input" id="ja_radio" type="radio" value=1 v-model="languageRadio">
            <label class="area_radio_label" for="ja_radio">
                日本語
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="en_radio" type="radio" value=2 v-model="languageRadio">
            <label class="area_radio_label" for="en_radio">
              英語
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="kan_radio" type="radio" value=3 v-model="languageRadio">
            <label class="area_radio_label" for="kan_radio">
              韓国語
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="chu_han_radio" type="radio" value=4 v-model="languageRadio">
            <label class="area_radio_label" for="chu_han_radio">
              中国語(繁体字)
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="chu_kan_radio" type="radio" value=5 v-model="languageRadio">
            <label class="area_radio_label" for="chu_kan_radio">
              中国語(簡体字)
            </label>
          </div>
        </div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button :disabled="$v.$invalid || this.updating" v-if="this.changeFlg" class="btn_general" v-on:click="areaUpdate()">更新</button>
        <button :disabled="$v.$invalid || this.updating" v-else class="btn_general" v-on:click="areaAdd()">追加</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_area">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-if="languageRadio == 1 || languageRadio == ''" class="td_content">
              <div class="index_name">町丁目名</div>
              <div class="index_name_sub">半角スラッシュ区切り(/)で記入することで、アプリ上で地域を選択する際に画面の階層を分けて表示することができます。</div>
              <div><input v-model.trim="$v.areaName.$model" type="text" class="area_input"/></div>
              <div class="message">
                <div v-if="$v.areaName.$dirty">
                  <div class="error" v-if="!$v.areaName.required">町丁目名は必須入力です。</div>
                  <div class="error" v-if="!$v.areaName.maxLength">町丁目名は{{ $v.areaName.$params.maxLength.max }}文字以内で入力してください。</div>
                  <div class="error" v-if="!$v.areaName.customAreaName">すでに登録されている町丁目名です。</div>
                </div>
              </div>
              <div class="index_name">町丁目(フリガナ)</div>
              <div><input v-model.trim="$v.areaFurigana.$model" type="text" class="area_input"/></div>
              <div class="message">
                <div v-if="$v.areaFurigana.$dirty">
                  <div class="error" v-if="!$v.areaFurigana.maxLength">町丁目(フリガナ)は{{ $v.areaFurigana.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
              <div class="index_name">町丁目コード</div>
              <div><input v-model.trim="$v.areaCode.$model" type="text" class="area_input"/></div>
              <div class="message">
                <div v-if="$v.areaCode.$dirty">
                  <div class="error" v-if="!$v.areaCode.maxLength">町丁目コードは{{ $v.areaCode.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td v-if="languageRadio == 2" class="td_content">
              <div class="index_name">町丁目名(英語)</div>
              <div class="index_name_sub">半角スラッシュ区切り(/)で記入することで、アプリ上で地域を選択する際に画面の階層を分けて表示することができます。</div>
              <div><input v-model.trim="$v.areaName_ei.$model" type="text" class="area_input"/></div>
              <div class="message">
                <div v-if="$v.areaName_ei.$dirty">
                  <div class="error" v-if="!$v.areaName_ei.maxLength">町丁目名(英語))は{{ $v.areaName_ei.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td v-if="languageRadio == 3" class="td_content">
              <div class="index_name">町丁目名(韓国語)</div>
              <div class="index_name_sub">半角スラッシュ区切り(/)で記入することで、アプリ上で地域を選択する際に画面の階層を分けて表示することができます。</div>
              <div><input v-model.trim="$v.areaName_kan.$model" type="text" class="area_input"/></div>
              <div class="message">
                <div v-if="$v.areaName_kan.$dirty">
                  <div class="error" v-if="!$v.areaName_kan.maxLength">町丁目名(韓国語))は{{ $v.areaName_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td v-if="languageRadio == 4" class="td_content">
              <div class="index_name">町丁目名(中国語:繁体字)</div>
              <div class="index_name_sub">半角スラッシュ区切り(/)で記入することで、アプリ上で地域を選択する際に画面の階層を分けて表示することができます。</div>
              <div><input v-model.trim="$v.areaName_chu_han.$model" type="text" class="area_input"/></div>
              <div class="message">
                <div v-if="$v.areaName_chu_han.$dirty">
                  <div class="error" v-if="!$v.areaName_chu_han.maxLength">町丁目名(中国語:繁体字))は{{ $v.areaName_chu_han.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
            <td v-if="languageRadio == 5" class="td_content">
              <div class="index_name">町丁目名(中国語:簡体字)</div>
              <div class="index_name_sub">半角スラッシュ区切り(/)で記入することで、アプリ上で地域を選択する際に画面の階層を分けて表示することができます。</div>
              <div><input v-model.trim="$v.areaName_chu_kan.$model" type="text" class="area_input"/></div>
              <div class="message">
                <div v-if="$v.areaName_chu_kan.$dirty">
                  <div class="error" v-if="!$v.areaName_chu_kan.maxLength">町丁目名(中国語:簡体字))は{{ $v.areaName_chu_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

const customAreaName = (municipalityAreaNameList, changeFlg, areaNameDb) => (areaName) => {
  if (!areaName || areaName === "") {
    return true
  }

  console.log(municipalityAreaNameList)

  var areaSet = new Set(municipalityAreaNameList)

  if (changeFlg) {
    areaSet.delete(areaNameDb)
  }

  if (areaSet.has(areaName)) {
    return false
  } else {
    return true
  }
}

export default {
  data: function() {
    return {
      areaId: "",
      areaName: "",
      areaName_ei: "",
      areaName_kan: "",
      areaName_chu_han: "",
      areaName_chu_kan: "",
      areaFurigana: "",
      areaCode: "",
      // 変更フラグ
      changeFlg: false,
      // メッセージ
      message: "",
      updating: false,
      // radio
      languageRadio: 1,

      municipalityAreaList: null,
      municipalityAreaNameList: null,
      areaNameDb: "",
    }
  },
	mounted() {
    // 変更フラグ
    this.changeFlg = this.$store.getters.getStateChangeFlg
    // 変更の場合はStoreから設定
    if (this.changeFlg) {
      this.areaId = this.$store.getters.getStateAreaId
      this.areaDetail()
    }
    this.getMunicipalityArea()
    console.log(this.municipalityAreaNameList)
  },
  methods: {
    async getMunicipalityArea() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "municipality_area_list"
        }
      })

      this.municipalityAreaList = response.data
      this.municipalityAreaNameList = this.municipalityAreaList.map(x => x.area_name)
    },
    async areaDetail() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/detail', {
          params: {
            area_id: this.areaId
          }
        })
        this.areaName = response.data[0].area_name
        this.areaName_ei = response.data[0].area_name_ei
        this.areaName_kan = response.data[0].area_name_kan
        this.areaName_chu_han = response.data[0].area_name_chu_han
        this.areaName_chu_kan = response.data[0].area_name_chu_kan
        this.areaFurigana = response.data[0].area_furigana
        this.areaCode = response.data[0].area_code
        this.areaNameDb = response.data[0].area_name
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async areaAdd() {
      this.updating = true;
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area/add', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          area_name: this.areaName,
          area_name_ei: this.areaName_ei,
          area_name_kan: this.areaName_kan,
          area_name_chu_han: this.areaName_chu_han,
          area_name_chu_kan: this.areaName_chu_kan,
          area_furigana: this.areaFurigana,
          area_code: this.areaCode,
          charge_id: this.$store.getters.getStateChargeId
        })
        this.$router.push('/areaList')
      } catch (err) {
        this.message = err.response.data.errorMessage;
      }
      this.updating = false;
    },
    async areaUpdate() {
      this.updating = true;
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'area/update', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          area_id: this.areaId,
          area_name: this.areaName,
          area_name_ei: this.areaName_ei,
          area_name_kan: this.areaName_kan,
          area_name_chu_han: this.areaName_chu_han,
          area_name_chu_kan: this.areaName_chu_kan,
          area_furigana: this.areaFurigana,
          area_code: this.areaCode,
          charge_id: this.$store.getters.getStateChargeId
        })
        this.$router.push('/areaList')
      } catch (err) {
        this.message = err.response.data.errorMessage;
      }
      this.updating = false;
    }
  },
  validations() {
    return {
      areaName: {
        required,
        maxLength: maxLength(50),
        customAreaName: customAreaName(this.municipalityAreaNameList, this.changeFlg, this.areaNameDb)
      },
      areaName_ei: {
        maxLength: maxLength(50)
      },
      areaName_kan: {
        maxLength: maxLength(50)
      },
      areaName_chu_han: {
        maxLength: maxLength(50)
      },
      areaName_chu_kan: {
        maxLength: maxLength(50)
      },
      areaFurigana: {
        maxLength: maxLength(50)
      },
      areaCode: {
        maxLength: maxLength(50)
      }
    }
  }
}
</script>

<style scoped>
.area_radios_div {
  display: flex;
  margin: 0 0 0 30px;
}
.area_radio_div {
  margin: 0 10px 0 0;
  font-size: smaller;
}
.form-check-input {
  margin-left: -1.1rem;
}
.area_radio_label {
  margin: 2px 0 0 0;
}
table th.th_area {
  text-align: left;
  padding-left: 10px;
}
.td_content {
  text-align: left;
  padding: 20px 20px 0px 20px;
}
.index_name {
  padding: 0px 0px 5px 0px;
}
.index_name_sub {
  font-size: 0.9em;
  padding: 0px 0px 5px 0px;
}
.area_input {
  width: 758px;
}
</style>